import { render, staticRenderFns } from "./TimeSlot.vue?vue&type=template&id=165b9aff&scoped=true"
import script from "./TimeSlot.vue?vue&type=script&lang=js"
export * from "./TimeSlot.vue?vue&type=script&lang=js"
import style0 from "./TimeSlot.vue?vue&type=style&index=0&id=165b9aff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165b9aff",
  null
  
)

export default component.exports